/**
 * Dependency Injection symbols
 * Used with Inversify container for service registration
 */

/**
 * DI container type symbols
 */
export const DI_TOKENS = {
  /** Local storage store service */
  LocalStorageStore: Symbol.for('LocalStorageStore'),

  /** Counter store service */
  CounterStore: Symbol.for('CounterStore'),

  /** Authentication service */
  AuthStore: Symbol.for('AuthStore'),

  /** Conversations history store */
  ConversationsHistoryStore: Symbol.for('ConversationsHistoryStore'),

  /** Streaming store service */
  StreamingStore: Symbol.for('StreamingStore'),

  /** Assessment workflow UI orchestration store */
  AssessmentWorkflowStore: Symbol.for('AssessmentWorkflowStore'),
} as const;
